import { useState, useEffect } from 'react'
import Card, { CardHeader, CardTitle, CardBody } from './Card'
import Pill from './Pill'
import ToolCard from './ToolCard'
import axios from 'axios'

export default function ToolsList() {
  const [tools, setTools] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchTools = async () => {
      try {
        const response = await axios.get('/api/v1/tools', {
          timeout: 5000 // 5 second timeout
        })
        if (response.data && Array.isArray(response.data)) {
          setTools(response.data)
        } else {
          setTools([])
        }
      } catch (error) {
        console.error('Failed to fetch tools:', error)
        setTools([])
      } finally {
        setLoading(false)
      }
    }

    fetchTools()
  }, [])

  return (
    <section className="mt-8 mb-8" id="tools" aria-label="Tools">
      <Card>
        <CardHeader>
          <CardTitle>Tools I Use</CardTitle>
          <Pill>the stack</Pill>
        </CardHeader>
        <CardBody>
          <div className="grid grid-cols-1 gap-3 mt-1.5">
            {loading ? (
              <div className="text-muted-dark text-center py-8">Loading tools...</div>
            ) : tools.length > 0 ? (
              tools.map(tool => (
                <ToolCard key={tool._id} tool={tool} />
              ))
            ) : (
              <div className="text-muted-dark text-center py-8">No tools documented yet.</div>
            )}
          </div>
        </CardBody>
      </Card>
    </section>
  )
}

